import React from "react";
import AudioPlayer from "../AudioPlayer";

const LS_NAME = 'audioMessageRate';

const AudioModal = ({ url }) => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  let sourceUrl = url;
  if (isIOS && typeof sourceUrl === 'string') sourceUrl = sourceUrl.replace('.ogg', '.mp3');

  let initialRate = parseFloat(localStorage.getItem(LS_NAME) || '1');
  if (![1.0, 1.5, 2.0, 0.5].includes(initialRate)) initialRate = 1.0;

  const handlePlay = () => {
    // show rate button in previous UI; now we persist rate on play
    localStorage.setItem(LS_NAME, initialRate);
  };

  return (
    <AudioPlayer src={sourceUrl} initialRate={initialRate} onPlay={handlePlay} />
  );
};

export default AudioModal;